import React from "react";
import classNames from "classnames";
import type { MenuIconPros } from "./dto";
import styles from "./index.module.less";

export default function MenuIcon(props: MenuIconPros) {
  const { title, icon, style, className } = props;
  if (React.isValidElement(icon))
    return React.cloneElement(props.icon, {
      className,
      title,
      style: { display: "inline", ...style },
    });
  return (
    <img
      src={props.icon}
      alt="icon"
      className={classNames(props.className, styles.iconRect)}
      title={props.title}
      data-type={props.dataType}
      style={props.style}
    />
  );
}
